/** Role strings returned by the API (workspace.user_role). */
export const WORKSPACE_ROLE = {
  OWNER: 'owner',
  ADMIN: 'admin',
  MEMBER: 'member',
  GUEST: 'guest',
};

/** Human-readable labels for workspace roles. */
export const WORKSPACE_ROLE_LABEL = {
  [WORKSPACE_ROLE.OWNER]: 'Owner',
  [WORKSPACE_ROLE.ADMIN]: 'Admin',
  [WORKSPACE_ROLE.MEMBER]: 'Member',
  [WORKSPACE_ROLE.GUEST]: 'Guest',
};
